// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	HALLOWEEN_COSTUME_IDS,
	HALLOWEEN_COSTUME_RANDOM_ID,
	type HalloweenCostumeChoiceId,
	type HalloweenCostumeId,
	parseCostumeId,
} from '@fluxer/constants/src/HalloweenCostumeConstants';

export {
	COSTUME_FLIP_SUFFIX,
	formatCostumeId as formatCostumeChoice,
	HALLOWEEN_COSTUME_IDS,
	HALLOWEEN_COSTUME_NONE_ID,
	HALLOWEEN_COSTUME_RANDOM_ID,
	type HalloweenCostumeChoiceId,
	type HalloweenCostumeId,
	isHalloweenCostumeChoiceId,
	isHalloweenCostumeId,
	PARKED_HALLOWEEN_COSTUME_IDS,
} from '@fluxer/constants/src/HalloweenCostumeConstants';

/** Catalog fallback when a Randomize roll needs a concrete row (not the unpicked picker default). */
export const DEFAULT_HALLOWEEN_COSTUME_ID: HalloweenCostumeId = 'halloween.witch-hat-1';

/** Picker order: Randomize, then live catalog. */
export const HALLOWEEN_COSTUME_CHOICES: ReadonlyArray<HalloweenCostumeChoiceId> = [
	HALLOWEEN_COSTUME_RANDOM_ID,
	...HALLOWEEN_COSTUME_IDS,
];

/**
 * App rendering parse. Collapses never-picked and unrecognised junk to `{baseId: null}`.
 * Stats use `parseCostumeId`, which keeps the raw base and a `known` flag.
 */
export function parseCostumeChoice(rawId: string | null | undefined): {
	baseId: HalloweenCostumeChoiceId | null;
	flipped: boolean;
} {
	const parsed = parseCostumeId(rawId);
	if (!parsed.known || parsed.baseId == null) {
		return {baseId: null, flipped: false};
	}
	return {baseId: parsed.baseId as HalloweenCostumeChoiceId, flipped: parsed.flipped};
}
